import { render, staticRenderFns } from "./RequirementDelete.vue?vue&type=template&id=4532d7f5&scoped=true&"
import script from "./RequirementDelete.vue?vue&type=script&lang=js&"
export * from "./RequirementDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4532d7f5",
  null
  
)

export default component.exports